import { Injectable } from '@angular/core';

import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(public auth: AuthService) {}

  canActivate(): Promise<boolean> {
    return this.auth.isAuthenticated().then((authenticated) => {
      if (authenticated) {
        return true;
      } else {
        return false;
      }
    });
  }
}
